import { Stack } from "@mui/material";
import { AuthorizationResources } from "@rw1/permissions";
import React from "react";
import { useParams } from "react-router-dom";
import { PageLayout } from "../../components/PageLayout";
import { useCurrentUserRoles } from "../../hooks/useCurrentUserRoles";
import { ContentStack, PageContainer, PageTitle } from "./CompanyPage.styles";
import { AuditLogExportSection } from "./components/AuditLogExportSection";
import { CompanyInfo } from "./components/CompanyInfo";
import { useCompanyOverview } from "./hooks/useCompanyOverview";

export const CompanyPage: React.FC = () => {
  const {
    user,
    company,
    organizationName,
    organizationKey,
    initials,
    organizationLogoUrl,
    internalUsersCount,
    loading,
  } = useCompanyOverview();
  const { companyId } = useParams();
  const { userRoles, isLoading } = useCurrentUserRoles();
  const isGlobalAdmin = userRoles?.find(x => x.roleId === AuthorizationResources.Global.Group.Administrator) !== undefined;
  const isCompanyAdmin = userRoles?.find(x => x.organizationId == companyId && x.roleId === AuthorizationResources.Global.Group.Company_Administrator) !== undefined
  const isContentVisible = !isLoading && (isCompanyAdmin || isGlobalAdmin);

  return (
    <PageLayout isLoading={loading}>
      <PageContainer>
        <ContentStack spacing={3}>
          <Stack spacing={{ xs: 2, md: 3 }}>
            <PageTitle>{organizationName}</PageTitle>


            {isContentVisible &&
              <CompanyInfo
                initials={initials}
                internalUsersCount={internalUsersCount}
                organizationKey={organizationKey}
                organizationLogoUrl={organizationLogoUrl}
                organizationName={organizationName}
              />}
          </Stack>

          {/* Audit Log Export */}
          {isContentVisible &&
            <AuditLogExportSection company={company} user={user} />
          }
        </ContentStack>
      </PageContainer>
    </PageLayout>
  );
};
